import React from "react";

import Modal from "@material-ui/core/Modal";
import ModalFade from "components/modal/ModalFade";
import Backdrop from "@material-ui/core/Backdrop";

const MaterialModal = ({ children, open, closeModal }) => {
  return (
    <Modal
      aria-labelledby="spring-modal-title"
      aria-describedby="spring-modal-description"
      className="popup-wrap"
      open={open}
      onClose={closeModal}
      closeAfterTransition
      disableScrollLock={true}
      BackdropComponent={Backdrop}
      outline={0}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <ModalFade in={open} className="center2">
        {children}
      </ModalFade>
      {/* <div>{children}</div> */}
    </Modal>
  );
};

export default MaterialModal;
